import { useEffect, useState } from 'react';
import { Link } from 'react-router';
import { Controller, useForm } from 'react-hook-form';
import { useRecoveryStore } from '@lib/store';
import { useRouteHook } from '@shared/hook';
import { DateUtils, RoutePaths } from '@shared/utils';
import { Button, Input, Select } from '@shared/widgets';

const MONTHS = [
  { leftLabel: 'January', value: '01' },
  { leftLabel: 'February', value: '02' },
  { leftLabel: 'March', value: '03' },
  { leftLabel: 'April', value: '04' },
  { leftLabel: 'May', value: '05' },
  { leftLabel: 'June', value: '06' },
  { leftLabel: 'July', value: '07' },
  { leftLabel: 'August', value: '08' },
  { leftLabel: 'September', value: '09' },
  { leftLabel: 'October', value: '10' },
  { leftLabel: 'November', value: '11' },
  { leftLabel: 'December', value: '12' },
];

interface IForm {
  firstName: string;
  lastName: string;
  birthPlace: string;
  month?: { leftLabel: string; value: string };
  day?: { leftLabel: string; value: string };
  year?: { leftLabel: string; value: string };
}
const DEFAULT_VALUES: IForm = { firstName: '', lastName: '', birthPlace: '', month: undefined, day: undefined, year: undefined };

export const PasswordResetForm = () => {
  const { navigate } = useRouteHook();

  const recoveryStore = useRecoveryStore();

  const [daysOptions, setDaysOptions] = useState<{ value: string; leftLabel: string }[]>([]);

  const { control, formState, handleSubmit, watch } = useForm<IForm>({ defaultValues: DEFAULT_VALUES });
  const month = watch('month');
  const year = watch('year');

  useEffect(() => {
    setDaysOptions(DateUtils.generateDays(month!, year));
  }, [month, year]);

  const submitHandler = async (data: IForm) => {
    await recoveryStore.recovery({
      BirthDate: `${data.year?.value}-${data.month?.value}-${data.day?.value}`,
      BirthPlace: data.birthPlace,
      FirstName: data.firstName,
      LastName: data.lastName,
    });
    navigate(RoutePaths.login.onNavigate());
  };

  return (
    <section className='flex flex-col gap-4.5'>
      <div className='text-center text-sm text-[#fcfcfc] uppercase'>RECOVER PASSWORD</div>
      <form className='flex flex-col gap-4' onSubmit={handleSubmit(submitHandler)}>
        <Controller
          name='firstName'
          control={control}
          rules={{ required: true }}
          render={({ field }) => <Input {...field} className='animat-input' placeholder='FIRST NAME' required />}
        />
        <Controller
          name='lastName'
          control={control}
          rules={{ required: true }}
          render={({ field }) => <Input {...field} className='animat-input' placeholder='LAST NAME' required />}
        />
        <div className='flex justify-between gap-2'>
          <Controller
            name='month'
            control={control}
            rules={{ required: true }}
            render={({ field: { value, onChange } }) => (
              <Select
                placeholder='MONTH'
                items={MONTHS}
                value={value?.value}
                onChange={onChange}
                selectWidth='w-[140%] z-10 left-[-20%] top-[-10%] '
              />
            )}
          />
          <Controller
            name='day'
            control={control}
            rules={{ required: true }}
            render={({ field: { value, onChange } }) => (
              <Select
                placeholder='DAY'
                items={daysOptions}
                value={value?.value}
                onChange={onChange}
                selectWidth='w-[140%] z-10 left-[-20%] top-[-10%]'
              />
            )}
          />
          <Controller
            name='year'
            control={control}
            rules={{ required: true }}
            render={({ field: { value, onChange } }) => (
              <Select
                placeholder='YEAR'
                items={DateUtils.generateYears()}
                value={value?.value}
                onChange={onChange}
                selectWidth='w-[140%] z-10 left-[-20%] top-[-10%]'
              />
            )}
          />
        </div>
        <Controller
          name='birthPlace'
          control={control}
          rules={{ required: true }}
          render={({ field }) => <Input {...field} className='animat-input' placeholder='PLACE OF BIRTH' required />}
        />
        <Button className='animat-btn-in mt-5.5 h-[56px]' fullWidth type='submit' disabled={!formState.isValid || formState.isSubmitting}>
          SEND REQUEST
        </Button>
      </form>
      <Link to={RoutePaths.recovery.onNavigate()}>
        <Button className='mt-3.5 h-[56px]' fullWidth color='outlined'>
          Cancel
        </Button>
      </Link>
    </section>
  );
};
